import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { queryClient } from "App";
import axiosInstance from "axiosConfig";
import {
  ActivateSubscription,
  ActivateSubscriptionResponse,
} from "types/SubscriptionTypes";

export const useActivateSubscription = (
  options?: UseMutationOptions<ActivateSubscriptionResponse, Error, ActivateSubscription>
) => {
  return useMutation({
    ...options,
    mutationKey: ["activateSubscription"],
    mutationFn: async (data) => {
      return axiosInstance
        .post("/subscriptions", {
          ...data,
        })
        .then((res) => res.data);
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ["customers"] });
      queryClient.invalidateQueries({ queryKey: ["subscriptions"] });
      queryClient.invalidateQueries({ queryKey: ["me"] });

      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useActivateSubscription;
